/**
 * 初回イベント作成チュートリアルの Context オブジェクトと型定義。
 *
 * Provider（EventTutorialContext.tsx）と hook（hooks/useEventTutorial.ts）から
 * 参照する。コンポーネント以外のエクスポートを分離し、Fast Refresh を保つ。
 */
import { createContext } from 'react';

export type EventTutorialPhase =
  | 'idle'
  // CreateEvent ページ（AI相談）
  | 'create-ai-button' // AI企画ボタンをスポットライト（タップ）
  | 'create-ai-form-intro' // AIモーダル: 質問エリア（人数・時期・内容）の解説
  | 'create-ai-form' // AIモーダル: 生成ボタンを押させる
  // CreateEvent ページ（提案の確認）
  | 'create-ai-result-title' // 結果: タイトル・説明の解説
  | 'create-ai-result-details' // 結果: 日時・場所・予算の解説
  | 'create-ai-result-invite' // 結果: 招待メッセージの解説
  | 'create-ai-result-accept' // 結果: 採用ボタンを押させる
  // CreateEvent ページ（内容の確認→公開）
  | 'create-review-datetime' // フォーム: 候補日の解説
  | 'create-review-title' // フォーム: タイトルの解説
  | 'create-review-description' // フォーム: 説明の解説
  | 'create-review-detail' // フォーム: 詳細情報の解説
  | 'create-publish' // 公開ボタンを押させる
  // EventDetail ページ
  | 'detail-share' // 「作成しました」モーダルを閉じさせる
  | 'detail-tabs' // 5タブの概要
  | 'detail-participants' // 参加者タブ（投票結果）
  | 'detail-tools' // ツールタブ（便利ツール追加）
  | 'detail-comments' // コメントタブ
  | 'detail-history' // 履歴タブ
  | 'detail-finish' // 削除 or このまま使う の確認
  | 'detail-delete'; // 削除方法のガイド

export interface EventTutorialContextValue {
  phase: EventTutorialPhase;
  tutorialEventId: string | null;
  /** ツアーが進行中か */
  isActive: boolean;
  /** CreateEvent ページでツアーを開始する */
  startCreateTour: () => void;
  /** 現在のフェーズを更新する */
  setPhase: (phase: EventTutorialPhase) => void;
  /** チュートリアルで作成したイベントIDを記録する */
  setTutorialEventId: (eventId: string) => void;
  /** ツアーを終了して状態をクリアする */
  endTour: () => void;
}

export const EventTutorialContext = createContext<EventTutorialContextValue | null>(null);
